// export const BASE_URL = "https://insights-qa.gna.energy";
export const BASE_URL = "https://api-data.gna.energy";
export const AGENT_API_BASE = "https://gnai-agent.gna.energy";
// export const BASE_URL = "http://192.168.1.243:8000";
export const APP_TOKEN = "Apptoken";

// https://api-data.gna.energy
